<template>
  <card>
    <h4 slot="header" class="card-title">Compañía</h4>
    <form v-if="company">
      <div class="row">
        <div class="col-md-6">
          <base-input type="text"
                    label="Nombre"
                    :disabled="true"
                    placeholder="Compañía"
                    v-model="company.name">
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input type="text"
                    label="Dirección"
                    :disabled="true"
                    placeholder="Dirección"
                    v-model="company.address">
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <base-input type="text"
                    label="Ciudad"
                    :disabled="true"
                    placeholder="Ciudad"
                    v-model="company.city">
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input v-if="company.status==true"
                    label="Estado"
                    :disabled="true"
                    placeholder="Estado"
                    value="Activo">
          </base-input>
          <base-input v-else
                    label="Estado"
                    :disabled="true"
                    placeholder="Estado"
                    value="Inactivo">
          </base-input>
        </div>
      </div>
      <div class="clearfix"></div>
    </form>
  </card>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'
  import getSecret from '../../helpers/get-secret';
  const serverUrl=getSecret('SERVER_URL');

  export default {
    components: {
      Card
    },
    data () {
      return {
        user: {
          name_company: JSON.parse(localStorage.getItem('jwt_licencia')).name,
          email: window.localStorage.getItem('jwt_user'),
        },
        id_company:JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
        company:null,
      }
    },
    methods: {
      getCompanyData(){
        this.axios.get(serverUrl+'/api/getCompanyData/'+this.id_company)
          .then(res => {   
            if(res.data.status == 200){
              this.company=res.data.company;
            }else {
              console.log(res.data);
            }
          })
          .catch(err => {
            console.log(err.data);
          });
      },
    },
    mounted(){
      this.getCompanyData();
    }
  }

</script>
<style>

</style>
